import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import { CustomPicker, /* ColorResult, Color, */ RGBColor, HSLColor } from 'react-color';
import { Saturation, Hue } from 'react-color/lib/components/common';

const hexToHsl = require('hex-to-hsl');

interface ColorPickerProps {
	value: string;
	label: string;
	open: boolean;
	className?: string;
	close?: () => void;
	styleProp?: React.CSSProperties;
}

function Pointer(props: any) {
	return (
		<div className="color-pointer" style={{ backgroundColor: 'none' }}>
		</div>
	);
}

function PointerHue(props: any) {
	return (
		<div className="color-pointer hue-pointer" style={{ backgroundColor: props.value }}>
		</div>
	);
}

function ColorPicker(props: ColorPickerProps | any) {
	const {
		value,
		label,
		open,
		close,
		className = '',
		styleProp,
	} = props;

	const [tempValue, setTempValue] = useState(value);

	function manualChange(e: React.ChangeEvent<HTMLInputElement>) {
		let hex = e.target.value;

		// set temp color value here for the input element - we don't want it to be exactly the same value
		// because we can't pass miscalculated values in the callback, so keep it separate until there is a
		// valid color change
		setTempValue(hex);

		// if user does not type in #, put it in
		if (!hex.startsWith('#')) hex = `#${hex}`;

		// don't bother with short hex strings like #fff, too hard to tell when to send the update
		if (hex.length !== 7) return;

		// build rgb from hex
		const r = parseInt(`0x${hex[1]}${hex[2]}`, 16);
		const g = parseInt(`0x${hex[3]}${hex[4]}`, 16);
		const b = parseInt(`0x${hex[5]}${hex[6]}`, 16);

		const rgb: RGBColor = { r, g, b };

		// use package here, hsl color is really verbose to build out
		const [h, s, l] = hexToHsl(hex);

		const hsl: HSLColor = { h, s, l };

		// call props.onChange which requires a ColorResult type from react-color
		props.onChange({ hex, hsl, rgb });
	}

	// when the user updates the color by changing the sliders, hard set tempValue to match what the user has picked
	useEffect(() => {
		setTempValue(value);
	}, [value]);

	return (
		<div className={classNames('color-picker-wrapper', className, { open })} style={styleProp || {}}>
			{open && !!close && <div className="color-picker-background" onClick={close} />}
			<div className={classNames('color-picker-container', { open })}>
				<div className="color-label"><label>{label}</label></div>
				<div className="select-container">
					<div className="saturation" style={{ position: 'relative' }}>
						<Saturation
							{...props}
							pointer={Pointer}
							onChange={props.onChange}
						/>
					</div>

					<div className="right-side">
						<div className="value-container">
							<label>HEX</label>
							<input
								type="text"
								className="color-value"
								contentEditable={true}
								onChange={manualChange}
								value={tempValue}
								onClick={(e) => e.stopPropagation()}
							/>
						</div>
						<div className="hue" style={{ position: 'relative' }}>
							<Hue
								{...props}
								pointer={PointerHue}
								onChange={props.onChange}
								radius={7}
							/>
						</div>
					</div>
				</div>

			</div>

		</div>
	);
}

export default CustomPicker(ColorPicker);
